import React from 'react';
import Page from '../components/Page';

const Vulnerabilidade = (props) => {
   return(
      <Page bg="/assets/img/vulnerabilidade-bg.jpg">
         <h1>Se sente vulnerável?</h1>
         <p>Se sente inseguro/vulnerável no ambiente de trabalho? Testemunhou alguma situação de vulnerabilidade? Sua contribuição é muito importante para você e todos os profissionais atuando no setor saúde. Neste site, você pode se sentir seguro. Há a possibilidade de enviar informações anonimamente. Seus dados pessoais, como e-mail e IP, não serão revelados.</p>
         <h3>Direito de resposta</h3>
         <p>Todo registro de manifestação abrirá a possibilidade do direito de resposta pelo responsável/gestor da instituição citada, de forma que a plataforma seja resolutiva dos problemas apresentados.</p>
         <h3>Perspectivas</h3>
         <p>Esta iniciativa prevê a geração/produção de conteúdo para divulgação na mídia e, caso necessário, encaminhamento das reclamações aos órgãos e autoridades que possam colaborar na defesa dos interesses coletivos. Assim, reforçamos a responsabilidade do informante pelas situações aqui registradas.</p>
      </Page>
   )
}

export default Vulnerabilidade;